var map = {
	"./about.webp": 1764,
	"./awards-winner.webp": 1290,
	"./awards.webp": 1291,
	"./bb-most-common.webp": 1765,
	"./bb-price.webp": 1766,
	"./bb-terms.webp": 1767,
	"./cb-statement.webp": 1768,
	"./current-account.webp": 1769,
	"./general-banking.webp": 1770,
	"./generic-quickstart.webp": 1771,
	"./guides-bg.webp": 1581,
	"./insurance-life-buoy.webp": 1772,
	"./insurance-piggy.webp": 1773,
	"./insurance-umbrella.webp": 1774,
	"./jumbo.webp": 1292,
	"./kettle.webp": 1775,
	"./lightbulbs.webp": 1776,
	"./location.webp": 1777,
	"./mortgage-questions.webp": 1778,
	"./mortgages.webp": 1228,
	"./nav-cta/banking.webp": 1521,
	"./nav-cta/broadband.webp": 1522,
	"./nav-cta/energy.webp": 1523,
	"./nav-cta/insurance.webp": 1524,
	"./nav-cta/latest-news.webp": 1525,
	"./nav-cta/mortgages.webp": 1526,
	"./podcast-bg.webp": 1527,
	"./podcast-image.webp": 1528,
	"./podcast.webp": 1529,
	"./stats.webp": 1560,
	"./tips-for-households.webp": 1779
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1763;